export const AUTH_CODE_COOKIE = 'notion-auth-code';
export const AUTH_ERROR_COOKIE = 'notion-auth-error';
